<template>
  <div class="error-msg-box">
    You don't have access to the microphone
    <div class="triangle"></div>
  </div>
</template>

<script>
  export default {
    name: 'ErrorMsgBox'
  }
</script>

<style lang="scss">
@import "ErrorMsgBox";
</style>
